var version = {
    "name":      "dativery",
    "buildDateCode": "20260309-144145",
    "buildDate": "Mon Mar 09 2026 14:41:45 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260309-144145",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;